import React from "react";
import { Stack } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import Input from "src/components/Input";
import { FormLabel } from "src/components/atoms/FormLabel";

export const AdjustmentAmount = () => {
  const { control } = useFormContext();

  const fieldName = "adjustmentAmount";

  return (
    <Stack gap={2}>
      <FormLabel htmlFor={fieldName} required={true}>
        Adjustment Amount
      </FormLabel>
      <Controller
        control={control}
        name={fieldName}
        rules={{ required: true }}
        render={({ field: { name, value, onChange, ref }, fieldState: { error } }: any) => (
          <Input
            type={"number"}
            controlId={fieldName}
            name={name}
            value={value}
            placeholder={`Enter adjustment amount`}
            onChange={onChange}
            ref={ref}
            error={error}
          />
        )}
      />
    </Stack>
  );
};
